// Which things count as a "card", and how their entrance is staggered (pure, so it can be tested).

const CARD_LOOK = /\brounded-(lg|xl|2xl|3xl)\b/;
const CARD_SURFACE = /\b(border|shadow|bg-)/;

// The admin panel and the sign-in page keep their plain look.
export function animatesOn(pathname) {
  return !/^\/(admin|login)(\/|$)/.test(pathname || "");
}

// A card is a roomy, rounded, bordered or tinted box - not a chip, a button or a field.
export function looksLikeCard(className, { width = 0, height = 0, tag = "div" } = {}) {
  const name = typeof className === "string" ? className : "";
  if (["button", "input", "textarea", "select", "label", "li"].includes(String(tag).toLowerCase())) return false;
  if (!CARD_LOOK.test(name) || !CARD_SURFACE.test(name)) return false;
  return width >= 120 && height >= 80 && height <= 900;          // a very tall block is a page section, not a card
}

// Cards in the same row/grid arrive one after another, but never wait more than `cap` steps.
export function staggerDelay(index, { step = 80, cap = 6 } = {}) {
  const i = Math.max(0, Math.floor(Number(index) || 0));
  return Math.min(i, cap) * step;
}
